module.exports = __webpack_public_path__ + "static/img/ldt4.898d468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/ldt4.png
// module id = f4dy
// module chunks = 0